// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorPage_container__sGlGH {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #ffffff;
  box-sizing: border-box;
}

.ErrorPage_card__zHiAr {
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 48px;
  border-radius: 8px;
  box-sizing: border-box;
}

.ErrorPage_icon__EU711 {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 16px;
}

.ErrorPage_arrowIcon__1B7xf {
  width: 20px;
  height: 20px;
}

.ErrorPage_title__qpHSs {
  margin: 0;
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
  color: #333333;
  text-align: center;
  margin-bottom: 12px;
}

.ErrorPage_subtitle__jgAey {
  margin: 0;
  max-width: 520px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #666666;
  text-align: center;
}

/* Go back button */
.ErrorPage_goBack__MpylN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #d9d9d9;
  padding: 14px 24px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  transition: transform 0.12s ease, background 0.12s ease;
  margin-top: 24px;
  box-shadow: 0px 4px 8px 0px #0000000A;

}

.ErrorPage_goBack__MpylN:hover {
  transform: translateY(-1px);
  background: #fcffed;
}

.ErrorPage_goBack__MpylN:active {
  transform: scale(0.98);
}

.ErrorPage_goBackIcon__fjnRy {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333333;
}

/* Single mobile breakpoint */
@media (max-width: 480px) {
  .ErrorPage_card__zHiAr {
    padding: 36px 20px;
    align-items: center;
  }

  .ErrorPage_icon__EU711 {
    margin-bottom: 16px;
  }

  .ErrorPage_title__qpHSs {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 8px;
  }

  .ErrorPage_subtitle__jgAey {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    padding: 0 6px;
  }

  .ErrorPage_goBack__MpylN {
    padding: 10px 14px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ErrorPage/index.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;;AAEvC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: #ffffff;\n  box-sizing: border-box;\n}\n\n.card {\n  width: 100%;\n  max-width: 760px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 64px 48px;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.icon {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n  margin-bottom: 16px;\n}\n\n.arrowIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.title {\n  margin: 0;\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 42px;\n  color: #333333;\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.subtitle {\n  margin: 0;\n  max-width: 520px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #666666;\n  text-align: center;\n}\n\n/* Go back button */\n.goBack {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  padding: 14px 24px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 16px;\n  color: #333333;\n  transition: transform 0.12s ease, background 0.12s ease;\n  margin-top: 24px;\n  box-shadow: 0px 4px 8px 0px #0000000A;\n\n}\n\n.goBack:hover {\n  transform: translateY(-1px);\n  background: #fcffed;\n}\n\n.goBack:active {\n  transform: scale(0.98);\n}\n\n.goBackIcon {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #333333;\n}\n\n/* Single mobile breakpoint */\n@media (max-width: 480px) {\n  .card {\n    padding: 36px 20px;\n    align-items: center;\n  }\n\n  .icon {\n    margin-bottom: 16px;\n  }\n\n  .title {\n    font-size: 20px;\n    line-height: 28px;\n    text-align: center;\n    margin-bottom: 8px;\n  }\n\n  .subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    padding: 0 6px;\n  }\n\n  .goBack {\n    padding: 10px 14px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ErrorPage_container__sGlGH`,
	"card": `ErrorPage_card__zHiAr`,
	"icon": `ErrorPage_icon__EU711`,
	"arrowIcon": `ErrorPage_arrowIcon__1B7xf`,
	"title": `ErrorPage_title__qpHSs`,
	"subtitle": `ErrorPage_subtitle__jgAey`,
	"goBack": `ErrorPage_goBack__MpylN`,
	"goBackIcon": `ErrorPage_goBackIcon__fjnRy`
};
export default ___CSS_LOADER_EXPORT___;
